import { Helmet } from 'react-helmet-async';
import { useNavigate } from "react-router-dom";
import '../../assets/styles/GraphicsDesign.css'
import brandingImg from "../../assets/images/Brand Identity Design.png";
import logoImg from "../../assets/images/Logo Design.png";
import printImg from "../../assets/images/Print Design.png";
import socialImg from "../../assets/images/Social Media Design.png";

const Graphics = () => {
    const navigate = useNavigate();

    const graphicServices = [
  {
    title: "Brand Identity Design",
    description: "Crafting cohesive brand identities including typography, color schemes, and visual tone.",
    image: brandingImg,
    path: "/services/graphics/branding"
  },
  {
    title: "Logo Design",
    description: "Creating unique and memorable logos tailored to your brand values and audience.",
    image: logoImg,
    path: "/services/graphics/logo"
  },
  {
    title: "Print Design",
    description: "Designing high-quality brochures, flyers, banners, and business cards for print media.",
    image: printImg,
    path: "/services/graphics/print"
  },
  {
    title: "Social Media Design",
    description: "Creating visually consistent and engaging graphics for social media campaigns.",
    image: socialImg,
    path: "/services/graphics/social"
  }
];

  return (
    <>
    <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Graphic Design Services – BuddyTech Solutions </title>
        <meta name="description" content="Branding, logo, print and social media graphics designed to elevate your brand." />
        <meta name="keywords" content="graphic design, branding, logo, print, social media" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Graphic Design Services – BuddyTech Solutions" />
        <meta property="og:description" content="Branding, logo, print and social media graphics designed to elevate your brand." />
        <meta property="og:keywords" content="graphic design, branding, logo, print, social media" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/graphics" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Graphic Design Services – BuddyTech Solutions" />
        <meta name="twitter:description" content="Branding, logo, print and social media graphics designed to elevate your brand." />
        <meta name="twitter:keywords" content="graphic design, branding, logo, print, social media" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
 </Helmet>
    <div className="graphics-container">
      <header className="graphics-hero">
        <h1>Graphics Design Services</h1>
        <p>Discover our design solutions tailored to enhance brand identity and user engagement.</p>
      </header>
      <section className="graphics-services">
        {graphicServices.map((service, index) => (
          <div className="graphics-card" key={index} onClick={() => navigate(service.path)}>
            <img src={service.image} alt={service.title} className="graphics-card-img" />
            <div className="graphics-card-body">
              <h2>{service.title}</h2>
              <p>{service.description}</p>
              <button className="graphics-btn">Explore</button>
            </div>
          </div>
        ))}
      </section>
    </div>
    </>
  )
}

export default Graphics
